/**
 * Storage hook.
 *
 * Based on link but customized: https://dev.to/devlargs/nextjs-hook-for-accessing-local-or-session-storage-variables-3n0
 */

type UseStorageReturnValue = {
	getItem: (key: string) => string;
	setItem: (key: string, value: string) => boolean;
	removeItem: (key: string) => void;
	clear: () => void;
};

const useStorage = (): UseStorageReturnValue => {
	const isBrowser: boolean = ((): boolean => typeof window !== "undefined")();

	const getItem = (key: string): string => {
		return isBrowser && key && window?.localStorage?.getItem(key) ? window.localStorage?.getItem(key) || "" : "";
	};

	const setItem = (key: string, value: string): boolean => {
		if (isBrowser) {
			window.localStorage.setItem(key, value);
			return true;
		}

		return false;
	};

	const removeItem = (key: string): void => {
		window.localStorage.removeItem(key);
	};

	const clear = (): void => {
		window.localStorage.clear();
	};

	return {
		getItem,
		setItem,
		removeItem,
		clear,
	};
};

export default useStorage;
